import { Popup, Tabs, Tab, List, CellGroup, Cell, Image, Popover, Button } from 'vant'
import { mapState } from 'vuex'
import ldButton from 'Common/ldButton'
import AMap from 'Views/Car/carQuery/AMap'
import MescrollVue from 'mescroll.js/mescroll.vue'
import map_location from './img/map-location.png'
import map_land_active from './img/map-land-active.png'
import map_traffic from './img/map-traffic.png'
import map_traffic_active from './img/map-traffic-active.png'
import map_food from './img/map-food.png'
import map_food_active from './img/map-food-active.png'
import map_shopping from './img/map-shopping.png'
import map_shopping_active from './img/map-shopping-active.png'
import map_scenic from './img/map-scenic.png'
import map_scenic_active from './img/map-scenic-active.png'
import map_hotel from './img/map-hotel.png'
import map_hotel_active from './img/map-hotel-active.png'
import { secondsToMins } from '@/business/utils/dateUtil'
import { metreToKm } from '@/business/utils/string'
import defaultMixin from '../../../../mixins/default'

const dc = (tag) => {
  return document.createElement(tag)
}

export default {
  name:'HtNavMap',
  mixins:[defaultMixin],
  components: {
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [Popover.name]: Popover,
    [Button.name]: Button,
    HtContactItem: () => import('Views/Ht/htQuery/htContactItem/index.vue'),
    ldButton,
    MescrollVue,
  },
  data() {
    return {
      active: 2,
      isShow: false,
      mapInstance: {},
      mapLoaded: false,
      centerPostion: [],
      centerMarker: null,
      landMarker: null,
      down: { use: false },
      nearbyFacilityTab: [
        {
          name: 'Transport',
          pageNum: 0,
          pageSize: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          label: '交通',
          keywords: '地铁|火车|公交|机场',
          type: '交通设施服务',
          list: [],
          overlays: [],
          icon: {
            normal: map_traffic,
            active: map_traffic_active
          }
        },
        {
          name: 'Dining',
          pageNum: 0,
          pageSize: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          label: '美食',
          keywords: '美食',
          type: '餐饮服务',
          list: [],
          overlays: [],
          icon: {
            normal: map_food,
            active: map_food_active
          }
        },
        {
          name: 'LandScape',
          pageNum: 0,
          pageSize: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          label: '景点',
          keywords: '景点',
          type: '道路附属设施|地名地址信息|公共设施|生活服务|体育休闲服务',
          list: [],
          overlays: [],
          icon: {
            normal: map_scenic,
            active: map_scenic_active
          }
        },
        {
          name: 'Shopping',
          pageNum: 0,
          pageSize: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          label: '购物',
          keywords: '',
          type: '购物服务',
          list: [],
          overlays: [],
          icon: {
            normal: map_shopping,
            active: map_shopping_active
          }
        },
        {
          name: 'Hotel',
          pageNum: 0,
          pageSize: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          label: '酒店',
          keywords: '',
          type: '住宿服务',
          list: [],
          overlays: [],
          icon: {
            normal: map_hotel,
            active: map_hotel_active
          }
        },
      ],
      mode: 0, // 0 - 驾车  1 - 步行
      activeData: {
        facility: null,
        f_i: 0,
        i: 0
      },
      createListMarkerAutoFitView: false
    }
  },
  computed: {
    ...mapState({
      model: (state) => state.ht.htSearchInfo,
      data_: (state) => state.ht.orderDetails,
    }),
    jdmc () {
      if (this.model._international == 1 && this.$route.query.lon && this.$route.query.lat) {
        this.data_.hotelCnName = this.data_.jdmc
        this.data_.hotelEnName = this.data_.jden
      }

      return this.model._international == 0 ? this.data_.jdmc : (this.data_.hotelCnName + '('+ this.data_.hotelEnName+')')
    }
  },
  async mounted () {
    if (this.$route.query.lon && this.$route.query.lat) {
      const { lng, lat } = await AMap.convertFrom([this.$route.query.lon, this.$route.query.lat], 'baidu')
      this.centerPostion = [lng, lat]
    }

    this.loadMap()
  },
  methods: {
    loadMap () {
      this.mapInstance = new AMap({
        id: 'ht-nav-map',
        zoom: 14,
        center: this.centerPostion,
        plugins: ['AMap.PlaceSearch', 'AMap.Driving', 'AMap.Walking'],
        mapMount: () => {
          this.addMarker(this.data_)
          this.mapLoaded = true
        }
      })
    },
    async addMarker (element) {
      let AMapInstance = this.mapInstance.AMapInstance,
        map = this.mapInstance.map

      let Container = this.createFacilityInfoWindowDocument(true)

      let centerInfoWindow = new AMapInstance.InfoWindow({
        isCustom: true,  //使用自定义窗体
        content: Container,  //传入 dom 对象，或者 html 字符串
        offset: new AMapInstance.Pixel(0, -55),
      })

      this.centerMarker = this.mapInstance.addMarker({
        content: `<img src="${map_location}" width="32">`,
        name: element.jdid,
        position: this.centerPostion,
        offset: [-16, -32], // 相对于基点的偏移位置
        zIndex: 999
      }).on('click', () => {
        centerInfoWindow.open(map, this.centerPostion)
      })

      /**
       * 如果是外面地标查询的列表
       * 默认规划路线
       */
      if (this.model.searchType == 3) {
        centerInfoWindow.open(map, this.centerPostion)

        const { lng, lat } = await AMap.convertFrom([this.model.lon, this.model.lat], 'baidu')

        this.landMarker = this.mapInstance.addMarker({
          content: `<img src="${map_land_active}" width="32">`,
          name: 'map_land_active',
          position: [lng, lat],
          offset: [-4, -32]
        }).on('click', () => {
          new AMapInstance.InfoWindow({
            isCustom: true,
            content : `
              <div class="van-popup van-popover van-popover--light htMap__nav--marker" data-popper-placement="top">
                <div class="van-popover__arrow" style="border-width: 13px;"></div>
                <div class="van-popover__content" style="width: auto;">
                  <div class="font-bold title" style="margin-bottom: auto;">${this.model._keywords}</div>
                </div>
              </div>
            `,
            offset: new AMapInstance.Pixel(0, -55),
          }).open(map, [lng, lat])
        })

        if (!this.createListMarkerAutoFitView) {
          this.mapInstance.drivingSearch(
            this.centerPostion,
            [lng, lat],
            () => {
              return {
                options: {
                  hideMarkers: true,
                  autoFitView: false
                }
              }
            }
          )

          this.mapInstance.map.setFitView(
            [this.centerMarker, this.landMarker],
            null,
            [210, this.isShow ? 300 : 120, 100, 100]
          )
        }
      } else {
        this.createListMarkerAutoFitView = true
      }

    },
    facilityListOnLoad (i) {
      let	tab = this.nearbyFacilityTab[i]

      tab.pageNum ++
      if (tab.name === 'Hotel') {
        this.getNearHotelList(i)
      } else {
        this.getFacilityList(i)
      }
    },
    /**
     * 根据关键字 获取附近的POI
     */
    async getFacilityList (i) {
      if (!this.mapInstance) return

      let AMapInstance = this.mapInstance.AMapInstance,
        tab = this.nearbyFacilityTab[i]

      if (tab.pageNum === 0) return

      tab.loading = true
      //构造地点查询类
      var placeSearch = new AMapInstance.PlaceSearch({
        city: this.model._cityName || this.model._city, // 兴趣点城市
        citylimit: true,  //是否强制限制在设置的城市内搜索
        type: tab.type,
        pageIndex: tab.pageNum,
        pageSize: tab.pageSize,
        extensions: 'all'
      })

      // var result = {'info':'OK','poiList':{'pois':[{'id':'B03017V5IJ','name':'九天商务酒店(东莞南城店)','type':'住宿服务;宾馆酒店;三星级宾馆','location':{'Q':22.989488,'R':113.74850300000003,'lng':113.748503,'lat':22.989488},'address':'西平宏伟路中段九天大厦','tel':'0769-23092999','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'provider':'','title':'Logo','url':'http://store.is.autonavi.com/showpic/37e3dc2d39b846db1141f5a6e4fd2237'},{'provider':'','title':'酒店外观','url':'http://store.is.autonavi.com/showpic/ff580a0ecec7b99f7e4e685063c23806'},{'provider':'','title':'','url':'http://store.is.autonavi.com/showpic/c44ee8df804c4c90c89d7f8a6b70462f'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B03017V0K6','name':'三屯工业大道','type':'地名地址信息;交通地名;道路名','location':{'Q':22.952918,'R':113.67494199999999,'lng':113.674942,'lat':22.952918},'address':'东莞市','tel':'','distance':null,'shopinfo':'2','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':'','entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B03017UVCP','name':'新塘街','type':'地名地址信息;交通地名;道路名','location':{'Q':22.7807,'R':114.03753899999998,'lng':114.037539,'lat':22.7807},'address':'东莞市','tel':'','distance':null,'shopinfo':'2','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':'','entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B03017UQ0E','name':'东莞市宏宝汽车销售服务有限公司','type':'汽车销售;宝马特约销售;宝马销售|汽车维修;宝马特约维修;宝马维修|公司企业;公司企业;公司企业','location':{'Q':23.013162,'R':113.852125,'lng':113.852125,'lat':23.013162},'address':'寮步镇东莞国际汽车城内','tel':'0769-81106333;0769-81106988;0769-82312982','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'title':'','url':'http://store.is.autonavi.com/showpic/bd7417bcd206d6005c1876a311048de7'},{'title':'','url':'http://store.is.autonavi.com/showpic/30a4043a789818cbd2aee71af2fc89aa'},{'title':'','url':'http://store.is.autonavi.com/showpic/9d6230a1473d2a4559aadfa67bd4139f'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B03017UNBJ','name':'国美城商务酒店','type':'住宿服务;宾馆酒店;四星级宾馆','location':{'Q':22.931424,'R':113.66648900000001,'lng':113.666489,'lat':22.931424},'address':'S256省道莞太路段河田路口对面(西南角)','tel':'0769-81630888','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'provider':'','title':'客房','url':'http://store.is.autonavi.com/showpic/5111a9e7515ae3f1aae85c8f9256fe3a'},{'provider':'','title':'','url':'http://store.is.autonavi.com/showpic/404f0e7feeadc10d875a743dde77d76f'},{'provider':'','title':'客房','url':'http://store.is.autonavi.com/showpic/6579f7452425e36f24bfd9927fde79c2'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B03017U9Y7','name':'东莞完美酒店','type':'住宿服务;宾馆酒店;宾馆酒店','location':{'Q':23.008588,'R':113.76404000000002,'lng':113.76404,'lat':23.008588},'address':'鸿福东路东城明苑大厦C座(靠近会展中心)','tel':'0769-23131888','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'provider':'','title':'Logo','url':'http://store.is.autonavi.com/showpic/1100b114205622de62a6860d3ee5d1b4'},{'provider':'','title':'客房','url':'http://store.is.autonavi.com/showpic/8831fe017898562d4336574b72f3550d'},{'provider':'','title':'','url':'http://store.is.autonavi.com/showpic/59df0b00c8384832ed2b72f55ade07ac'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B03017TYON','name':'共联商业街','type':'地名地址信息;交通地名;道路名','location':{'Q':23.035029,'R':113.70588199999997,'lng':113.705882,'lat':23.035029},'address':'东莞市','tel':'','distance':null,'shopinfo':'2','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':'','entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B030100QYS','name':'黄河时装城','type':'购物服务;服装鞋帽皮具店;服装鞋帽皮具店','location':{'Q':22.81726,'R':113.67560300000002,'lng':113.675603,'lat':22.81726},'address':'虎门镇虎门大道92号','tel':'0769-85108888;13724516866','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'title':'','url':'http://store.is.autonavi.com/showpic/9e789680868969549972138dfb0790b7'},{'title':'','url':'http://store.is.autonavi.com/showpic/d7c18eef8def7460f92884ecfed1f2b9'},{'title':'','url':'http://store.is.autonavi.com/showpic/24acc8c8a69b5e3071bbb2194b4b1305'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B030100N6L','name':'世博商务酒店','type':'住宿服务;宾馆酒店;四星级宾馆','location':{'Q':23.032965,'R':113.77894400000002,'lng':113.778944,'lat':23.032965},'address':'东莞大道世博广场J座1楼(距地铁东城站D出口50米,近万达广场)','tel':'0769-22762222;0769-22761112','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'provider':'','title':'Logo','url':'http://store.is.autonavi.com/showpic/c6af0a110e7f653ccce9d247ad7c7b8e'},{'provider':'','title':'酒店外观','url':'http://store.is.autonavi.com/showpic/cde483872ded8320a09dfdb7d70b6cfd'},{'provider':'','title':'','url':'http://store.is.autonavi.com/showpic/d95fd5e678703f7695e1f5bd49e5517d'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false},{'id':'B030100FRL','name':'东莞东荣酒店','type':'住宿服务;宾馆酒店;四星级宾馆','location':{'Q':23.019831,'R':113.75884300000001,'lng':113.758843,'lat':23.019831},'address':'新城市中心簪花路(体育路与簪花路交汇口南行约300米)','tel':'0769-22822666','distance':null,'shopinfo':'0','pname':'广东省','cityname':'东莞市','adname':'东莞市','photos':[{'provider':'','title':'Logo','url':'http://store.is.autonavi.com/showpic/ebfa9f539c6e569e69e5cedba5dca493'},{'provider':'','title':'酒店外观','url':'http://store.is.autonavi.com/showpic/ea0c8a2697cb5ee323f9684861bfe542'},{'provider':'','title':'外观','url':'http://store.is.autonavi.com/showpic/42a7e58118f0c82d8de5ad8c69692e06'}],'entr_location':null,'exit_location':null,'groupbuy':true,'discount':true,'indoor_map':false}],'count':861,'pageIndex':86,'pageSize':10}}
      // tab.list = result.poiList.pois

      // tab.finished = true
      // console.log(tab.list)

      // 关键字 查询
      placeSearch.searchNearBy(tab.keywords, this.centerPostion, 5000, (status, result) => {

        let data = result.poiList.pois
        tab.loading = false

        if (data.length < tab.pageSize) {
          tab.finished = true
        }

        if (tab.pageNum > 1) {
          tab.list.push(...data)
        } else {
          tab.list = data
        }

        this.createListMarker(i, data)
      })
    },
    // 获取附近酒店
    getNearHotelList (i) {
      let	tab = this.nearbyFacilityTab[i]

      this.$api['htQuery/hotelList']({
        singaZhid: this.model.singaZhid,
        platZhid: this.model.platZhid,
        checkOutDate: this.model._checkOutDate.date,
        checkInDate: this.model._checkInDate.date,
        cityId: this.model.cityId,
        lat: this.$route.query.lat,
        lon: this.$route.query.lon,
        searchType: 3,
        pageNum: tab.pageNum,
      }).then(async (res) => {
        let arr = res.data ? res.data.list ? res.data.list : [] : [] // 请求的列表数据

        for (let hotel of arr) {
          hotel.name = hotel.jdmc
          hotel.id = hotel.jdid

          const { lng, lat } = await AMap.convertFrom([hotel.baiduLon, hotel.baiduLat], 'baidu')
          hotel.location = { lng, lat }
        }

        if (arr.length < tab.pageSize) tab.finished = true
        if (tab.pageNum === 1) tab.list = [] // 如果是第一页需手动置空列表
        tab.list.push(...arr) // 把请求到的数据添加到列表

        this.createListMarker(i, arr)
      }).catch(() => {
        tab.error = true
      })
    },
    createListMarker (i, data) {
      let tab = this.nearbyFacilityTab[i]

      data.forEach((facility, j) => {
        let marker = this.mapInstance.addMarker({
          content: `<img src="${tab.icon.normal}" width="36">`,
          zIndex: j,
          name: facility.id,
          position: [facility.location.lng, facility.location.lat], // 基点位置
          offset: [-18, -36] // 相对于基点的偏移位置
        }).on('click', () => {
          this.changeFoucsFacility(facility, j, i)
        })

        tab.overlays[ (tab.pageNum - 1) * 10 + j ] = marker
      })

      if (this.createListMarkerAutoFitView) {
        this.mapInstance.map.setFitView(
          [...tab.overlays, this.centerMarker],
          null,
          [100, this.isShow ? 300 : 100, 100, 100]
        )
      } else {
        this.createListMarkerAutoFitView = true
      }

    },
    /**
     * 创建窗口信息
     * @param {*} isCurHotel 是不是创建当前酒店的窗口  否为创建附近周边的窗口
     * @param {*} distance 创建周边窗口才传入 距离
     * @param {*} duration 创建周边窗口才传入 时间/分
     * @param {*} facility 周边实例
     * @param {*} tab 当前选中的tab
     * @returns
     */
    createFacilityInfoWindowDocument (isCurHotel, distance, duration, facility, tab) {
      let Container = dc('div')
      Container.classList = 'van-popup van-popover van-popover--light htMap__nav--marker'
      Container.setAttribute('data-popper-placement', 'top')

      let Arrow = dc('div')
      Arrow.classList = 'van-popover__arrow'
      Arrow.style.borderWidth = '13px'

      let Content = dc('div')
      Content.classList = 'van-popover__content'

      Container.appendChild(Arrow)
      Container.appendChild(Content)

      let title = dc('div')
      title.classList = 'font-bold title'
      if (isCurHotel) {
        title.innerHTML = `${this.jdmc}`
      } else {
        title.innerHTML = `${facility.name}`
      }

      let panel = dc('div')
      panel.classList = 'van-row van-row--flex van-row--align-bottom'

      Content.appendChild(title)
      Content.appendChild(panel)

      let distance_dom = dc('div')
      distance_dom.classList = 'van-col van-col--14 distance'
      if (isCurHotel) {
      } else if (tab.name === 'Hotel') {
        let level = facility.category || facility.starRate,
          levelString = '经济型'
        if (level == '5') {
          levelString = '豪华型'
        } else if (level == '4') {
          levelString = '高档型'
        } else if (level == '3') {
          levelString = '舒适型'
        }

        if (facility.score && facility.score != '0') {
          distance_dom.innerHTML += `<span class="main-color">${facility.score}分</span>  `
        }
        distance_dom.innerHTML += `<span class="main-color">${levelString}</span>  `

        distance_dom.innerHTML += `
          <p class="font12 orange">
            ¥ <span class="font18 red font-bold">${facility.price || facility.lowRate}</span> 起
          </p>
        `
      } else {
        distance_dom.innerHTML = `<span class="gray font12">${this.mode === 1 ? '步行' : '驾车'}距离${distance}公里，约${duration}分钟</span>`
      }

      let nav_btn_dom = dc('div')
      nav_btn_dom.classList = 'van-col van-col--10'

      panel.appendChild(distance_dom)
      panel.appendChild(nav_btn_dom)

      // 导航按钮
      let nav_btn = dc('button')
      nav_btn.classList = 'ld-button van-button van-button--default van-button--normal ld-button-sm main linear-main1 nav-btn'
      nav_btn.innerHTML = '<div class="van-button__content"><span class="van-button__text">导 航</span></div>'
      nav_btn.onclick = () => {
        if (isCurHotel) {
          this.locationNavToHotel()
        } else {
          this.navigator(facility)
        }
      }

      nav_btn_dom.appendChild(nav_btn)

      return Container
    },
    nearbyFacilityTabChange (i) {
      this.nearbyFacilityTab.forEach(tab => {
        tab.pageNum = 0
        tab.list = []
        tab.overlays = []
        tab.loading = false
        tab.finished = false
      })

      let AMapInstance = this.mapInstance.AMapInstance,
        tab = this.nearbyFacilityTab[i]

      this.mapInstance.map.clearMap()
      if (this.mapInstance.drivingInstance) {
        this.mapInstance.drivingInstance.clear()
      }
      if (this.mapInstance.walkingInstance) {
        this.mapInstance.walkingInstance.clear()
      }

      this.addMarker(this.data_)

      tab.loading = true

      this.facilityListOnLoad(i)
    },
    changeFoucsFacility (facility, f_i, i) {
      this.activeData.facility = facility
      this.activeData.f_i = f_i
      this.activeData.i = i

      let AMapInstance = this.mapInstance.AMapInstance,
        map = this.mapInstance.map,
        tab = this.nearbyFacilityTab[i],
        marker = tab.overlays[f_i]

      // 改变选项的聚焦
      tab.list.forEach((f, j) => {
        if (facility.id != f.id && f.active) {
          f.active = false
          this.changeHtMapMarker(i, tab.overlays[j], false)
        }
      })

      if (facility.active) return

      this.$set(facility, 'active', true)

      this.changeHtMapMarker(i, marker, true)

      this.modeSearch(facility, f_i, i)
    },
    modeSearch (
      facility = this.activeData.facility,
      f_i = this.activeData.f_i,
      i = this.activeData.i
    ) {
      let location = facility.location,
        tab = this.nearbyFacilityTab[i]

      if (this.mode === 1) {
        if (this.mapInstance.drivingInstance) {
          this.mapInstance.drivingInstance.clear()
        }

        this.mapInstance.walkingSearch(
          this.centerPostion,
          [location.lng, location.lat],
          () => {
            return {
              options: {
                hideMarkers: true,
                autoFitView: false,
                map: tab.name === 'Hotel' ? null : this.mapInstance.map
              },
              walkingSearchComplete: (result) => {
                this.routesPlanningComplete(facility, f_i, i, result)
              }
            }
          }
        )
      } else {
        if (this.mapInstance.walkingInstance) {
          this.mapInstance.walkingInstance.clear()
        }

        this.mapInstance.drivingSearch(
          this.centerPostion,
          [location.lng, location.lat],
          () => {
            return {
              options: {
                hideMarkers: true,
                autoFitView: false,
                map: tab.name === 'Hotel' ? null : this.mapInstance.map
              },
              drivingSearchComplete: (result) => {
                this.routesPlanningComplete(facility, f_i, i, result)
              }
            }
          }
        )
      }
    },
    routesPlanningComplete (facility, f_i, i, result) {
      let AMapInstance = this.mapInstance.AMapInstance,
        map = this.mapInstance.map,
        tab = this.nearbyFacilityTab[i],
        marker = tab.overlays[f_i]

      const distance = metreToKm(result.routes[0].distance)
      const duration = secondsToMins(result.routes[0].time)

      let Container = this.createFacilityInfoWindowDocument(false, distance, duration, facility, tab)

      new AMapInstance.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: Container,
        offset: new AMapInstance.Pixel(0, -75),
      }).open(map, marker.getPosition())

      this.mapInstance.map.setFitView(
        [this.centerMarker, marker],
        null,
        [210, this.isShow ? 300 : 120, 100, 100]
      )

    },
    // 对地图标记的图片更换放大
    changeHtMapMarker (i, marker, bool) {
      let AMapInstance = this.mapInstance.AMapInstance,
        tab = this.nearbyFacilityTab[i]

      if (bool) {
        marker.setContent(`<img src="${tab.icon.active}" width="48">`)
        marker.setOffset(new AMapInstance.Pixel(-24, -57))
      } else {
        marker.setContent(`<img src="${tab.icon.normal}" width="36">`)
        marker.setOffset(new AMapInstance.Pixel(-18, -36))
      }
    },
    /**
     * 我的位置导航到酒店
     */
    async locationNavToHotel () {
      if (this.model.searchType == 3) {
        const { lng, lat } = await AMap.convertFrom([this.model.lon, this.model.lat], 'baidu')

        AMap.openMap(
          { lng, lat },
          this.model._keywords,
          { lng: this.centerPostion[0], lat: this.centerPostion[1] },
          this.jdmc,
        )
      } else {
        AMap.openMap(
          false, false,
          { lng: this.centerPostion[0], lat: this.centerPostion[1] },
          this.jdmc,
        )
      }
    },
    /**
     * 导航到附近周边
     */
    navigator (facility) {
      let location = facility.location
      AMap.openMap(
        { lng: this.centerPostion[0], lat: this.centerPostion[1] },
        this.jdmc,
        { lng: location.lng, lat: location.lat },
        facility.name
      )
    },
    /**
     * 当前酒店到传入地点的直线距离
     * @param {*} facility 地点
     * @returns 公里数值
     */
    distance (facility) {
      let location = facility.location
      return this.mapInstance.distanceOfTwoPos(this.centerPostion, [location.lng, location.lat])
    },
    /**
     * 一般高德的photos数组里，第二张图片为门牌图片
     * @param {*} facility 地点
     * @returns 图片url
     */
    facilityPhotos (facility, f_i, i) {
      if (facility.photos) {
        if (facility.photos[1]) {
          return facility.photos[1].url
        } else if (facility.photos[0]) {
          return facility.photos[0].url
        }
      }

      return ''
    }
  }
}
